import Vue from 'vue'
import moment from 'moment'
Vue.filter('status', function (value) {
  return (value) ? "ACTIVO" : "INACTIVO"
})

Vue.filter('number', function (value) {
  return (value) ? new Intl.NumberFormat().format(value) : 0
})

Vue.filter('formatDate', function (value) {
  if (value) {
    const temp = moment(value).format('DD-MM-YYYY hh:mm')
    if (temp.toString() === 'Invalid date') {
      return moment.utc(value.toString()).format("DD-MM-YYYY hh:mm")
    } else {
      return temp
    }
  }
})
